type Settings = {
  session_token: string;
  ga_tracking: string;
  contact_phone_number: string;
};

declare global {
  var SETTINGS: Settings;
  var Rollbar: any;
}

export const getSessionToken = (): string => {
  return global.SETTINGS?.session_token || "unset";
};
